var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddresIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "black",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6985 17.7475L36.136 15.0025C35.8939 14.8471 35.6307 14.7274 35.3545 14.647C35.0796 14.5573 34.7931 14.5077 34.504 14.5H24.25L25.4515 22H34.504C34.75 22 35.0575 21.9445 35.353 21.853C35.6485 21.7615 35.9335 21.6355 36.1345 21.499L39.697 18.751C39.8995 18.6145 40 18.433 40 18.25C40 18.067 39.8995 17.8855 39.6985 17.7475ZM22.75 11.5H21.25C21.0511 11.5 20.8603 11.579 20.7197 11.7197C20.579 11.8603 20.5 12.0511 20.5 12.25V17.5H15.496C15.247 17.5 14.941 17.5555 14.6455 17.6485C14.3485 17.7385 14.065 17.863 13.864 18.0025L10.3015 20.7475C10.099 20.884 10 21.067 10 21.25C10 21.4315 10.099 21.613 10.3015 21.7525L13.864 24.5005C14.065 24.637 14.3485 24.763 14.6455 24.853C14.941 24.9445 15.247 25 15.496 25H20.5V37.75C20.5 37.9489 20.579 38.1397 20.7197 38.2803C20.8603 38.421 21.0511 38.5 21.25 38.5H22.75C22.9489 38.5 23.1397 38.421 23.2803 38.2803C23.421 38.1397 23.5 37.9489 23.5 37.75V12.25C23.5 12.0511 23.421 11.8603 23.2803 11.7197C23.1397 11.579 22.9489 11.5 22.75 11.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddresIcon);
export default __webpack_public_path__ + "static/media/addresIcon.b6efd96de5ce3b13561c0d3537ec6692.svg";
export { ForwardRef as ReactComponent };